module.exports = __webpack_public_path__ + "img/districts.681adb2d.svg";